import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {IntranetoldService} from '../../../api/intranetold.service'
import { Columns, Config, DefaultConfig } from 'ngx-easy-table';
import {DocumentoMarketingDetalle, DocumentoMarting} from "./../../../model/ventaModel"
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'app-selectedDireccion',
  templateUrl: './listaDireccion.html',
  styleUrls: ['./venta.component.sass']
})
export class listaDireccionComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private _api: IntranetoldService
  ) { }

  data = {
      "Street": "",
      "City":"",
      "ZipCode":"",
      "County":"",
      "State":"",
      "Country": "CL"
  }
  ngOnInit(): void {
    if (!this.data.Country)
    {
        this.data.Country = "CL";
    }
    this.cargaInicial();
  }


  OCRY:any;
  OCST:any;
  async cargaInicial()
  {


   
    var objeto = "SELECT [Code], [Name] FROM [OCRY]";
    var dato:any = await this._api.GetNotFileQuery(objeto);
    this.OCRY = dato.objeto;

    objeto = "SELECT * FROM [OCST] WHERE [Country] = '" + this.data.Country + "'";
    dato = await this._api.GetNotFileQuery(objeto);
    this.OCST = dato.objeto;

  
  }

  cerrar() {
    this.activeModal.close();
  }
  eventEmitted($event): void {
    //this.clicked = JSON.stringify($event);

    var data:any = $event.value.row;
    // || $event.event == "onClick"
    if ($event.event == "onDoubleClick") {


     
      
      
    }
    if ($event.event == "onDoubleClick") {


      this.Seleccionar();      
    }
  
  }
  Seleccionar()
  {
    this.activeModal.close(this.data);
  }
}